import { SettingsShell } from 'shared/settings';
import { usePartnerData } from '@/providers/PartnerData.provider';
import PartnerSettingsApiProvider from './PartnerSettingsApiProvider';
import SettingsPageRoutes from './SettingsPageRoutes';
import useSettingsHostProps from './useSettingsHostProps';

export default function SettingsPage() {
  const settingsHostProps = useSettingsHostProps();

  const {
    response: { isRoleViewOnly },
  } = usePartnerData();

  return (
    <SettingsShell {...settingsHostProps}>
      <PartnerSettingsApiProvider readOnly={isRoleViewOnly}>
        <SettingsPageRoutes />
      </PartnerSettingsApiProvider>
    </SettingsShell>
  );
}
